export const canvasSetSmoothing = (ctx, value) => {
    var _a, _b, _c;
    const aCtx = ctx;
    const currentValue = ((_c = (_b = (_a = aCtx.imageSmoothingEnabled) !== null && _a !== void 0 ? _a : aCtx.mozImageSmoothingEnabled) !== null && _b !== void 0 ? _b : aCtx.msImageSmoothingEnabled) !== null && _c !== void 0 ? _c : aCtx.webkitImageSmoothingEnabled);
    aCtx.imageSmoothingEnabled = value;
    aCtx.mozImageSmoothingEnabled = value;
    aCtx.msImageSmoothingEnabled = value;
    aCtx.webkitImageSmoothingEnabled = value;
    return currentValue;
};
export function getCanvas2d(canvas) {
    return canvas.getContext('2d', { alpha: false });
}
export const toBlob = (canvas, type, quality) => {
    if (!canvas) {
        return Promise.reject(new Error('Invalid canvas'));
    }
    const opts = {
        type: type !== null && type !== void 0 ? type : 'image/jpeg',
        quality: Math.max(0, Math.min(quality !== null && quality !== void 0 ? quality : 1, 1)),
    };
    // Offscreencanvas
    if ('convertToBlob' in canvas) {
        return canvas.convertToBlob(opts);
    }
    // HTMLCanvasElement
    if ('toBlob' in canvas) {
        return new Promise((resolve, reject) => {
            canvas.toBlob(blob => {
                if (blob) {
                    resolve(blob);
                }
                else {
                    reject(new Error('Export error'));
                }
            }, opts.type, opts.quality);
        });
    }
    return Promise.reject('Object should be one of HTMLCanvasElement of OffscreenCanvas');
};
